import Web3 from 'web3'
import { WHITEWHALE_ABI, WHITEWHALE_ADDRESS } from './config'
import detectEthereumProvider from '@metamask/detect-provider'

const ClickBuy = async () => {

  const provider = await detectEthereumProvider()

  if (provider) {
    const web3 = new Web3(provider)
    const account = await provider.request({ method: 'eth_requestAccounts' })
    const contract = new web3.eth.Contract(
      WHITEWHALE_ABI,
      WHITEWHALE_ADDRESS
    );
    const pricePaid = await contract.methods.pricePaid().call()
    console.log('Ethereum successfully detected!')
    const result = await contract.methods.buyMe().send({
      from: account[0],
      value: pricePaid * 2
      });
      console.log( result )


    }
   else {

    // if the provider is not detected, detectEthereumProvider resolves to null
    console.error('Please install MetaMask!')
  }
}

export default ClickBuy;
